import { render, staticRenderFns } from "./ResetNewPasswordComponent.vue?vue&type=template&id=041fe530&scoped=true"
import script from "./ResetNewPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ResetNewPasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./ResetNewPasswordComponent.vue?vue&type=style&index=0&id=041fe530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fe530",
  null
  
)

export default component.exports